<template>
  <div>
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Informacje zgłoszeniowe</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    </v-card>
    <v-card class="mt-2 pb-1">
      <v-form @submit.prevent="updateRunner"novalidate>
        <v-toolbar flat dense dark color="tertiary">
          <v-toolbar-title>TRENER</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="subheading text-xs-center mt-5">Wybierz trenera</div>
        <trainer-selection
          v-model="form.trainer"
          :options="availableTrainers"
          :formErrors="formErrors"
          @input="updateRunner">
        </trainer-selection>
        <v-layout row wrap justify-end>
          <v-flex class="step-buttons">
            <v-btn dark :to="{name: 'runner-application-data-package', params: {id: $route.params.id}}" class="mr-4" color="tertiary">Wstecz</v-btn>
            <v-btn v-if="updateMode" type="submit" color="primary">Dalej</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import {updateRunnerDataTrainer, getRunnerDataTrainer} from './api'
import * as types from '@/store/mutation-types'
import store from '@/store'
import { mapGetters } from 'vuex'
import TrainerSelection from './TrainerSelection'

export default {
  components: {TrainerSelection},
  validators: {
  },
  data () {
    return {
      updateMode: true,
      formErrors: {},
      availableTrainers: [],
      runner: {},
      form: {}
    }
  },
  computed: {
    ...mapGetters(['allPackagesFullOptions', 'allTrainersFullOptions', 'authUser', 'getPackageById', 'getTrainerById'])
  },
  beforeRouteEnter (to, from, next) {
    if (parseInt(to.params.id) === store.getters.authUser.id) {
      next()
    } else {
      next({name: 'login'})
    }
  },
  mounted () {
    getRunnerDataTrainer(this.$route.params.id).then((data) => {
      this.runner = data
      this.form = {...data}
      this.validation.reset()
      Promise.all([this.p1, this.p2]).then(() => {
        this.packageChange(this.runner.package)
      })
    })
  },
  created () {
    this.p1 = this.$store.dispatch(types.ALL_PACKAGES_REQUEST)
    this.p2 = this.$store.dispatch(types.ALL_TRAINERS_REQUEST)
  },
  watch: {
  },
  methods: {
    packageChange (value) {
      let packageData = this.getPackageById(value)
      if (packageData && packageData.trainer) {
        let trainer = this.getTrainerById(packageData.trainer)
        if (trainer) {
          this.availableTrainers = [trainer]
          this.form.trainer = trainer.id
        } else {
          this.availableTrainers = this.allTrainersFullOptions
        }
      } else {
        this.availableTrainers = this.allTrainersFullOptions
      }
    },
    updateRunner () {
      this.$validate().then(success => {
        if (success) {
          updateRunnerDataTrainer(parseInt(this.$route.params.id), this.form).then((data) => {
            this.validation.reset()
            this.$emit('runner-application-data-updated', data)
            this.$router.push({name: 'runner-application-data-first', params: {id: this.$route.params.id}})
            this.$store.dispatch(types.RUNNERS_TRAINER_REQUEST, this.form)
            return data
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>
<style>
div.v-list__tile__action div.v-input.v-input--selection-controls.v-input--checkbox.theme--light {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/runners/RunnerApplicationDataTrainer.vue